import { render, staticRenderFns } from "./TrustCustomerIdentityMisMatch.vue?vue&type=template&id=0ffa1f69&scoped=true"
import script from "./TrustCustomerIdentityMisMatch.vue?vue&type=script&lang=js"
export * from "./TrustCustomerIdentityMisMatch.vue?vue&type=script&lang=js"
import style0 from "./TrustCustomerIdentityMisMatch.vue?vue&type=style&index=0&id=0ffa1f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffa1f69",
  null
  
)

export default component.exports